import React from 'react';

const Logo = ({ className = "" }) => {
  return (
    <div className={`font-bold uppercase tracking-wide flex flex-wrap items-center ${className}`}>
      <span className="text-gold-500">DOUGLASTON</span>
      <span className="text-white ml-2">AUTO CARE</span>
    </div>
  );
};

export default Logo;